var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83862 3.5V2.5C9.83862 2.22386 10.0625 2 10.3386 2H15.3376C15.6138 2 15.8376 2.22386 15.8376 2.5V3.5C15.8376 3.77614 15.6138 4 15.3376 4H10.3386C10.0625 4 9.83862 3.77614 9.83862 3.5Z",
    fill: "#697377"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3384 8.99969H11.3384C11.6145 8.99969 11.8384 9.22354 11.8384 9.49969V17.4997C11.8384 17.7758 11.6145 17.9997 11.3384 17.9997H10.3384C10.0623 17.9997 9.83838 17.7758 9.83838 17.4997V9.49969C9.83838 9.22354 10.0623 8.99969 10.3384 8.99969Z",
    fill: "#697377"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3384 8.99969H14.3384C14.0623 8.99969 13.8384 9.22354 13.8384 9.49969V17.4997C13.8384 17.7758 14.0623 17.9997 14.3384 17.9997H15.3384C15.6145 17.9997 15.8384 17.7758 15.8384 17.4997V9.49969C15.8384 9.22354 15.6145 8.99969 15.3384 8.99969Z",
    fill: "#697377"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3384 6.99969H19.8384L19.3706 21.033C19.3527 21.572 18.9105 21.9997 18.3712 21.9997H7.30554C6.76624 21.9997 6.3241 21.572 6.30615 21.033L5.83838 6.99969H4.33838C4.06226 6.99969 3.83838 6.77583 3.83838 6.49969V5.49969C3.83838 5.22356 4.06226 4.99969 4.33838 4.99969H21.3384C21.6145 4.99969 21.8384 5.22356 21.8384 5.49969V6.49969C21.8384 6.77583 21.6145 6.99969 21.3384 6.99969ZM17.8384 6.99969H7.83838L8.33838 19.9997H17.3384L17.8384 6.99969Z",
    fill: "#697377"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trashCan.85731000.svg";
export { ForwardRef as ReactComponent };